import { useTheme } from "@emotion/react";
import { LoadingButton } from "@mui/lab";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Card,
  Checkbox,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../../context/AuthContext";
const ConfirmTicketPaidDialog = ({
  salesTicketId,
  open,
  onClose,
  onConfirm,
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { authToken, ezorder } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleClose = () => {
    setErrorMessage("");
    onClose();
  };

  const handleConfirm = async () => {
    try {
      setLoading(true);
      const authHeader = {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      };
      const response = await ezorder.patch(
        `/sales-tickets/${salesTicketId}/status`,
        {
          status: "Paid",
        },
        authHeader
      );

      if (response.status == 200 || response.status === 201) {
        setErrorMessage("");
        onConfirm();
      } else {
        setErrorMessage(response.response.data.error);
      }
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        if (error.response.data?.error) {
          setErrorMessage(error.response.data.error);
        } else {
          setErrorMessage("Internal server error");
        }
      } else {
        setErrorMessage("Internal server error");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      fullScreen={isSmallScreen}
      maxWidth="md"
      fullWidth={true}
      open={open}
      onClose={() => {
        if (!loading) handleClose();
      }}
    >
      <DialogTitle>Mark Sales Ticket #{salesTicketId} as Paid</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Please confirm that there are no outstanding invoice balances for this
          sales ticket.
        </DialogContentText>
        <Box>
          {errorMessage && (
            <Box>
              <Typography color={"red"}>{errorMessage}</Typography>
            </Box>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          loading={loading}
          onClick={() => {
            if (!loading) handleClose();
          }}
        >
          Cancel
        </LoadingButton>
        <LoadingButton
          loading={loading}
          onClick={() => {
            setErrorMessage("");
            handleConfirm();
          }}
        >
          Mark as Paid
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmTicketPaidDialog;
